import React, { useEffect, useRef, useState } from 'react';
import axios from "axios";
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { classNames } from 'primereact/utils';
import { Dropdown } from 'primereact/dropdown';
import { MultiSelect } from 'primereact/multiselect';
import { useFormik } from 'formik';
import { Api } from '../../../services/api';
import moment from "moment";
import './Leads.css';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from "primereact/inputnumber";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { useParams, useNavigate } from 'react-router-dom';
import { Card } from 'primereact/card';
import { Message } from 'primereact/message';
import { FaTrash } from 'react-icons/fa';
import { Spinner } from 'react-bootstrap';
import { IoArrowBackSharp } from "react-icons/io5";
import { Checkbox } from 'primereact/checkbox';
import { Tag } from 'primereact/tag';
import { BsFillInfoCircleFill } from 'react-icons/bs';
import { IoIosCheckmark, IoMdCreate } from 'react-icons/io';
import { InputTextarea } from 'primereact/inputtextarea';
import { useMsal } from "@azure/msal-react";
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import EmailDialog from './EmailDialog';

// import { useHistory } from "react-router-dom";
const EditLeads = () => {
    const { instance, accounts } = useMsal();
    const navigate = useNavigate();
    const toast = useRef(null);
    const [isModalOpen, setIsModalOpen] = useState(true);
    const [type, setType] = useState('Add');
    const [declinedTypeList, setDeclinedTypeList] = useState([]);
    const [statusList, setStatusList] = useState([]);
    const [siteVisitStageList, setSiteVisitStageList] = useState([]);
    const [ceStageList, setCeStageList] = useState([]);
    const [fsaStageList, setFsaStageList] = useState([]);
    const [contractStageList, setContractStageList] = useState([]);
    const [constructionStartStageList, setConstructionStartStageList] = useState([]);
    const [completionStageList, setCompletionStageList] = useState([]);
    const [projectTypeList, setProjectTypeList] = useState([]);
    const [leadSourceList, setLeadSourceList] = useState([]);
    const [leadsId, setLeadsId] = useState(0);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showErrorDialog, setShowErrorDialog] = useState(false);
    const [showConfirmationDialog, setShowConfirmationDialog] = useState(false);
    const [showConfirmationDialogIsCall, setShowConfirmationDialogIsCall] = useState(false);
    const [errorTitle, setErrorTitle] = useState('');
    const [dateChangeOrNot, setDateChangeOrNot] = useState(false);
    const [showFsaConfirmDialog, setShowFsaConfirmDialog] = useState(false);
    const { editId } = useParams();
    const [debounceTimeout, setDebounceTimeout] = useState(null);
    const [notes, setNotes] = useState([]);
    const [emailThreads, setEmailThreads] = useState([]);
    const [isFormSubmit, setIsFormSubmit] = useState(false);

    const [projectsType, setProjectsType] = useState([]);
    const [projectsManager, setProjectsManager] = useState([]);
    const [projectId, setProjectId] = useState(0);
    const [isProject, setIsProject] = useState(false);

    const [editingNoteId, setEditingNoteId] = useState(null);
    const [editedNoteContent, setEditedNoteContent] = useState('');

    const [isDeleteConfirmationModalOpen, setIsDeleteConfirmationModalOpen] = useState(false);
    const [noteToDelete, setNoteToDelete] = useState(null);

    const [isAssigneeEmailOpen, setIsAssigneeEmailOpen] = useState(false);
    const [assigneeEmailData, setAssigneeEmailData] = useState({ subject: '', message: '', recipientIds: [] });
    const [isClientEmailOpen, setIsClientEmailOpen] = useState(false);

    // Helper functions for MS Graph
    const getAccessToken = async () => {
        if (accounts.length === 0) {
            // Optional: Auto login or just return null
             return null;
        }
    
        const request = {
          scopes: ["Mail.Read", "Mail.Send", "Mail.ReadWrite"],
          account: accounts[0]
        };
    
        try {
          const response = await instance.acquireTokenSilent(request);
          return response.accessToken;
        } catch (error) {
          if (error instanceof InteractionRequiredAuthError) {
            return instance.acquireTokenPopup(request).then((response) => {
              return response.accessToken;
            }).catch((error) => {
              console.error(error);
              return null;
            });
          } else {
             console.error(error);
            return null;
          }
        }
    };

    const formik = useFormik({
        initialValues: {
            year: '',
            client: '',
            first_name: '',
            last_name: '',
            address: '',
            street_number: '',
            street_name: '',
            city: '',
            postal_code: '',
            email: '',
            cilentInformation: '',
            phone_number: '',
            lead_source: '',
            project_type: '',
            project_value: '',
            project_desc: '',
            contact_date: '',
            declined_type: '',
            new_status: '',
            site_visit_date: '',
            site_visit_stage: '',
            contact_to_site_visit_days: '',
            ce_sent_out: '',
            ce_stage: '',
            site_visit_to_ce_days: '',
            fsa_date: '',
            fsa_stage: '',
            ce_to_fsa_days: '',
            contract_date: '',
            contract_stage: '',
            fsa_to_contract_days: '',
            construction_start_date: '',
            construction_start_stage: '',
            construction_to_start_days: '',
            completion_date: '',
            completion_stage: '',
            completion_to_construction_days: '',
            notes: '',
            sr_pm_notes: '',
            vp_of_construction_comments: '',
            user_id: '',
            projectCreated: 'project create',
            // notes: [],
            warranty_date: '',

            fsa_cancelled_date: '',
            contract_cancelled_date: '',
            assignee: '',
        },
        validate: (data) => {
            let errors = {};


            return errors;
        },

        onSubmit: (data) => {

        }
    });

    const formikProject = useFormik({
        initialValues: {
            projectName: "",
            projectType: "",
            hoursPerDay: "",
            pM: "",
            status: '',
            orig_expected_gp: "",
            project_cost_per: "",
            fixed_month: "",
            fixed_price: "",
            internal_job: "",
            actual_fees: "",
            actual_to_date: "",
            contract_amount: "",
            project_markup: "",
            project_cost_fee: "",
            is_margin_manual: "",
            pre_con_manager: "",
            interior_design: "",
            job_autospy: "",
            warranty: "",
            development_manager: "",
            sp_manager: "",
        },




        onSubmit: (data) => {
            data.job_autospy = data.pM;
            data.warranty = data.pM;

            const token = localStorage.getItem('authToken');

            // Create headers with token if it exists
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': token ? `Bearer ${token}` : ''
            };
            var url = Api.API_BASE_URL + 'project-update/' + projectId;
            fetch(url, {
                method: "POST",
                headers: headers,
                body: JSON.stringify(data),
            })
                .then((response) => response.json())
                .then((result) => {

                    if (result.error !== '') {
                        toast.current.show({ severity: 'error', detail: result.error });

                    } else {
                        toast.current.show({ severity: 'success', summary: 'Success', detail: result.result });
                        getLeadData()
                    }

                    // console.log(result);
                    setIsSavingProject(false);
                })
                .catch((error) => {
                    console.error("Error:", error);
                    setIsSavingProject(false);
                });
        }
    });



    const isFormFieldInvalid = (name) => !!(formik.touched[name] && formik.errors[name]);

    useEffect(() => {

        setIsModalOpen(true);
        getListData();
        setType('Add');
        getLeadData();
        getProjectType();
        return () => {
            // Cleanup tasks before the component is unmounted
        };
    }, [editId]);

    const getLeadData = async () => {
        // var leadId = 0;
        if (editId == undefined) {
            // leadId = editId;
            setIsFormSubmit(true);
            return true;
        }
        // if (leadsId != 0) {
        //     leadId = leadsId;
        // }

        // if (leadId == 0) {
        //     return true;
        // }
        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };
        axios.get(Api.API_BASE_URL + 'crm/get/' + editId, { headers })
            .then((response) => {
                // console.log('----------->>', response)
                const leadData = response.data.result;
                const notesData = response.data.notes;
                if (leadData) {
                    setLeadsId(leadData._id);
                    // console.log('----------->>', leadData.first_name)
                    editCopyModal(leadData, 'Edit');
                } else {
                    setIsFormSubmit(true);
                }
                if (notesData) {
                    setNotes(notesData);
                }
                // Fetch email threads using Graph API
                if (leadData && leadData.email) {
                    fetchEmailThreads(leadData.email);
                }

                const project = response.data.projects;
                if (project) {
                    setProjectId(project._id);
                    setIsProject(true);
                    formikProject.setValues({
                        projectName: project.project_name,
                        projectType: project.project_type,
                        hoursPerDay: project.hours_per_day,
                        pM: project.project_manager,
                        status: project.new_status,
                        orig_expected_gp: project.orig_expected_gp,
                        project_cost_per: 100 - project.project_cost_per,
                        fixed_month: project.fixed_month,
                        fixed_price: project.fixed_price,
                        internal_job: project.internal_job,
                        actual_fees: project.actual_fees,
                        actual_to_date: project.actual_to_date,
                        contract_amount: project.contract_amount,
                        project_markup: project.project_markup,
                        project_cost_fee: project.project_cost_fee,
                        is_margin_manual: project.is_margin_manual,
                        pre_con_manager: project.pre_con_manager,
                        interior_design: project.interior_design,
                        job_autospy: project.job_autospy,
                        warranty: project.warranty,
                        development_manager: project.development_manager,
                        sp_manager: project.sp_manager ?? '',
                    });

                }

            })


            .catch((error) => {
                setIsFormSubmit(true);
                console.error('Error fetching projects:', error);
            });
    }

    const getListData = async () => {
        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };
        axios.get(Api.API_BASE_URL + 'crm/get-dropdown-list', { headers })
            .then((response) => {
                setStatusList(response.data.new_status);
                // setDeclinedTypeList(response.data.declined_type);
                setProjectTypeList(response.data.project_type);
                setLeadSourceList(response.data.lead_source);
                setSiteVisitStageList(response.data.site_visit_stage);
                setCeStageList(response.data.ce_stage);
                setFsaStageList(response.data.fsa_stage);
                setContractStageList(response.data.contract_stage);
                setConstructionStartStageList(response.data.construction_start_stage);
                setCompletionStageList(response.data.completion_stage);
            })
            .catch((error) => {
                console.error('Error fetching projects:', error);
            });
    }

    //* ------ Api Call For Project Strat ----------------
    const getProjectType = async () => {
        const token = localStorage.getItem('authToken');

        // Create headers with token if it exists
        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };
        axios.get(Api.API_BASE_URL + 'crm/project-manager-and-project-type', { headers })
            .then((response) => {

                setProjectsType(response.data.projectType)
                setProjectsManager(response.data.projectManager)

            })
            .catch((error) => {
                console.error('Error fetching projects:', error);
            });

    }

    //! ------ Api Call For Project Strat ----------------

    const editCopyModal = (rowData, colType) => {
        // console.log('sssss', rowData);
        // console.log('sssss', rowData.first_name);
        // if (!rowData) {
        //     console.error("rowData is undefined or null");
        //     return; // Early return if rowData is not valid
        // }
        const modifiedUser = rowData.modified_by && rowData.modified_by.first_name && rowData.modified_by.last_name
            ? rowData.modified_by.first_name + ' ' + rowData.modified_by.last_name
            : '';


        formik.setValues({
            client: rowData.client,
            first_name: rowData.first_name,
            last_name: rowData.last_name,
            address: rowData.address,
            street_number: rowData.street_number,
            street_name: rowData.street_name,
            city: rowData.city,
            postal_code: rowData.postal_code,
            email: rowData.email,
            cilentInformation: rowData.cilentInformation,
            phone_number: rowData.phone_number,
            project_type: rowData.project_type,
            new_status: rowData.new_status,
            // contact_date: moment(rowData.contact_date).format('YYYY-MM-DD'),
            contact_date: rowData.contact_date ? rowData.contact_date.toString().substring(0, 10) : '',

            declined_type: rowData.declined_type,
            project_value: rowData.project_value,
            project_desc: rowData.project_desc,
            contact_to_site_visit_days: rowData.contact_to_site_visit_days,
            site_visit_to_ce_days: rowData.site_visit_to_ce_days,
            // ce_sent_out: moment(rowData.ce_sent_out).format('YYYY-MM-DD'),
            ce_sent_out: rowData.ce_sent_out ? rowData.ce_sent_out.toString().substring(0, 10) : '',

            site_visit_date: rowData.site_visit_date ? rowData.site_visit_date.toString().substring(0, 10) : '',
            lead_source: rowData.lead_source,
            site_visit_stage: rowData.site_visit_stage,
            ce_stage: rowData.ce_stage,
            ce_to_fsa_days: rowData.ce_to_fsa_days,
            fsa_stage: rowData.fsa_stage,
            fsa_date: rowData.fsa_date ? rowData.fsa_date.toString().substring(0, 10) : '',
            contract_stage: rowData.contract_stage,
            contract_date: rowData.contract_date ? rowData.contract_date.substring(0, 10) : '',
            development_date: rowData.development_date ? rowData.development_date.substring(0, 10) : '',
            fsa_to_contract_days: rowData.fsa_to_contract_days,
            construction_start_stage: rowData.construction_start_stage,
            construction_start_date: rowData.construction_start_date ? rowData.construction_start_date.substring(0, 10) : '',
            construction_to_start_days: rowData.construction_to_start_days,
            completion_stage: rowData.completion_stage,
            completion_date: rowData.completion_date ? rowData.completion_date.substring(0, 10) : '',
            completion_to_construction_days: rowData.completion_to_construction_days,


            warranty_date: rowData.warranty_date ? rowData.warranty_date.substring(0, 10) : '',

            //notes: rowData.notes,
            sr_pm_notes: rowData.sr_pm_notes,
            vp_of_construction_comments: rowData.vp_of_construction_comments,
            lead_status: rowData.status,
            who_referred_you: rowData.who_referred_you,

            addition_time: rowData.addition_time,
            // created_user: rowData.added_by.first_name + ' ' + rowData.added_by.last_name,
            created_user: (rowData.added_by.first_name && rowData.added_by.last_name)
                ? rowData.added_by.first_name + ' ' + rowData.added_by.last_name
                : '',
            modified_user: modifiedUser,
            leadsform: rowData.leadsform,
            modification_time: rowData.modification_time,
            assignee: rowData.assignee,


            fsa_cancelled_date: rowData.fsa_cancelled_date ? rowData.fsa_cancelled_date.substring(0, 10) : '',
            contract_cancelled_date: rowData.contract_cancelled_date ? rowData.contract_cancelled_date.substring(0, 10) : '',

        });

        setIsFormSubmit(true);
        setType(colType);
    };

    const [savedFields, setSavedFields] = useState({});
    const [isSavingProject, setIsSavingProject] = useState(false);
    const [isSavingNotes, setIsSavingNotes] = useState(false);

    //! Fetch email threads for this lead
    const fetchEmailThreads = async (leadEmail) => {
        if (!leadEmail) return;

        // Try to get token
        const token = await getAccessToken();
        if (!token) {
            console.log("No token available to fetch emails");
            return;
        }

        try {
            const targetEmail = leadEmail.trim().toLowerCase();
            // Use $search (requires ConsistencyLevel: eventual)
            // Or use $filter if we want to risk it (but we know recipients requires search)
            // Let's use the same query as in EmailDialog that worked: $search without orderby, client side sort.
            
            const searchQuery = `"participants:${targetEmail}"`;
            const url = `https://graph.microsoft.com/v1.0/me/messages?$search=${encodeURIComponent(searchQuery)}&$top=50&$select=id,conversationId,subject,body,from,toRecipients,ccRecipients,sentDateTime,receivedDateTime`;
            
            const response = await fetch(url, {
                headers: { 
                    Authorization: `Bearer ${token}`,
                    "ConsistencyLevel": "eventual" 
                }
            });

            if (response.ok) {
                const data = await response.json();
                // Sort client-side
                const messages = data.value.sort((a, b) => new Date(b.receivedDateTime) - new Date(a.receivedDateTime));

                // Group by conversationId like in EmailDialog
                const grouped = {};
                messages.forEach(msg => {
                    if (!grouped[msg.conversationId]) {
                        grouped[msg.conversationId] = {
                            thread_number: msg.conversationId,
                            subject: msg.subject,
                            messages: []
                        };
                    }
                    
                    const defaults = {
                        _id: msg.id,
                        direction: msg.from?.emailAddress?.address?.toLowerCase() === targetEmail ? 'incoming' : 'outgoing',
                        from_email: msg.from?.emailAddress?.address,
                        to_email: (msg.toRecipients?.map(r => r.emailAddress.address) || []).join(", "),
                        send_at: msg.sentDateTime || msg.receivedDateTime,
                        message: msg.body.content,
                        subject: msg.subject
                    };
                    grouped[msg.conversationId].messages.push(defaults);
                });

                const threads = Object.values(grouped).map((t, index) => ({
                    ...t,
                    thread_number: index + 1
                }));
                
                setEmailThreads(threads);
            }
        } catch (error) {
            console.error("Error fetching email history:", error);
            setEmailThreads([]);
        }
    };
    const getSavedSignatureImageSrc = () => {
        const rawSignature = localStorage.getItem('emailSignature') || '';
        const match = rawSignature.match(/<img[^>]+src=["']([^"']+)["'][^>]*>/i);
        return match ? match[1] : '';
    };

    const normalizeTimelineHtmlImages = (markup) => {
        if (!markup || !/<img[^>]*>/i.test(markup)) {
            return markup;
        }

        const fallbackImageSrc = getSavedSignatureImageSrc();

        try {
            const parser = new DOMParser();
            const parsedDocument = parser.parseFromString(markup, 'text/html');
            const root = parsedDocument.body;

            root.querySelectorAll('img').forEach((image) => {
                const src = (image.getAttribute('src') || '').trim();
                const normalizedSrc = src.toLowerCase();
                const needsFallback =
                    !src ||
                    normalizedSrc.startsWith('cid:') ||
                    normalizedSrc.includes('mail.google.com') ||
                    normalizedSrc.includes('outlook.office.com') ||
                    normalizedSrc.includes('outlook.office365.com') ||
                    normalizedSrc.includes('attachments.office.net');

                if (needsFallback && fallbackImageSrc) {
                    image.setAttribute('src', fallbackImageSrc);
                }

                if (fallbackImageSrc) {
                    image.setAttribute('onerror', "this.onerror=null;this.src='" + fallbackImageSrc + "';");
                } else {
                    image.setAttribute('onerror', "this.style.display='none';");
                }

                image.removeAttribute('originalsrc');
            });

            return root.innerHTML;
        } catch (error) {
            console.error('Timeline image normalization error:', error);
            return markup;
        }
    };

    const getSafeTimelineDate = (value) => {
        if (!value) {
            return new Date(0);
        }

        const parsedDate = new Date(value);
        if (!Number.isNaN(parsedDate.getTime())) {
            return parsedDate;
        }

        const momentDate = moment(value, [
            'YYYY-MM-DD HH:mm:ss',
            'YYYY-MM-DDTHH:mm:ss',
            'YYYY-MM-DDTHH:mm:ss.SSSZ',
            'MMM D, YYYY h:mm A'
        ], true);

        return momentDate.isValid() ? momentDate.toDate() : new Date(0);
    };

    //! Combine notes and emails into unified timeline
    const getCombinedTimeline = () => {
        const timeline = [];
        
        // Add notes
        notes.forEach(note => {
            timeline.push({
                type: 'note',
                id: note.id,
                date: getSafeTimelineDate(note.created_at),
                data: note
            });
        });

        // Add emails (flatten threads)
        emailThreads.forEach(thread => {
            thread.messages.forEach(msg => {
                timeline.push({
                    type: 'email',
                    id: msg._id,
                    date: getSafeTimelineDate(msg.send_at),
                    data: {
                        ...msg,
                        subject: thread.subject,
                        thread_number: thread.thread_number
                    }
                });
            });
        });

        // Sort by date (newest first)
        return timeline.sort((a, b) => b.date - a.date);
    };

    //! -------------------
    const onInputChange = (fieldName, value, rowData) => {

        formik.setFieldValue(fieldName, value);
        if (debounceTimeout) {
            clearTimeout(debounceTimeout);
        }
        const newTimeout = setTimeout(() => {
            if (isFormSubmit == false) {
                return;
            }
            var leadId = 0;
            if (editId !== undefined) {
                leadId = editId;
            }

            var _body = {
                userId: localStorage.getItem('user_id'),
                roleId: localStorage.getItem('role_id'),
                field_name: fieldName,
                field_value: value,
                id: leadsId
            }
            const token = localStorage.getItem('authToken');

            // Create headers with token if it exists
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': token ? `Bearer ${token}` : ''
            };

            var url = Api.API_BASE_URL + 'crm/save';
            fetch(url, {
                method: "POST",
                headers: headers,
                body: JSON.stringify(_body),
            })
                .then((response) => response.json())
                .then((Josn) => {
                    if (Josn.error !== '') {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });
                    } else {
                        setLeadsId(Josn.id);
                        if (fieldName === 'notes') {
                            var k = {
                                id: Josn.notesId,
                                notes: value,
                                name: localStorage.getItem('name'),
                                roles: localStorage.getItem('role_name'),
                                created_at: moment(new Date()).format('YYYY-MM-DD HH:mm:ss'),
                                image: localStorage.getItem('image')
                            }

                            var arr = [k, ...notes]
                            setNotes(arr);
                            // formik.setFieldValue('notes', value);
                            setIsSavingNotes(false);
                            formik.setFieldValue('notes', '');
                        }

                        if (['project_value', 'new_status', 'project_type', 'fsa_date', 'development_date'].includes(fieldName)) {
                            getLeadData();
                        }

                        if (fieldName == 'fsa_date' || fieldName == 'contract_date' || fieldName == 'construction_start_date' || fieldName == 'completion_date' || fieldName == 'warranty_date' || fieldName == 'new_status') {
                            getLeadData();
                        }
                        if (Josn.newlead === true) {
                            toast.current.show({ severity: 'success', summary: 'Success', detail: 'New Lead Is created successfully please fill all the Fields' });
                        }

                        setIsModalOpen(false);
                        setSavedFields((prevSavedFields) => ({ ...prevSavedFields, [fieldName]: true }));

                        setTimeout(() => {
                            setSavedFields((prevSavedFields) => ({ ...prevSavedFields, [fieldName]: false }));
                        }, 3000);
                    }
                })
                .catch((error) => {
                    console.error("Error:", error);
                })
                .finally(() => {
                    setIsSubmitting(false);
                });

        }, 1500);
        setDebounceTimeout(newTimeout);
    };

    const saveFieldImmediate = (fieldName, value) => {
        formik.setFieldValue(fieldName, value);
        
        var leadId = 0;
        if (editId !== undefined) {
            leadId = editId;
        }

        var _body = {
            userId: localStorage.getItem('user_id'),
            roleId: localStorage.getItem('role_id'),
            field_name: fieldName,
            field_value: value,
            id: leadsId
        }
        const token = localStorage.getItem('authToken');

        const headers = {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : ''
        };

        var url = Api.API_BASE_URL + 'crm/save';
        fetch(url, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(_body),
        })
        .then((response) => response.json())
        .then((Josn) => {
             if (Josn.error !== '') {
                  toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });
             } else {
                  setLeadsId(Josn.id);

                  if (['project_value', 'new_status', 'project_type', 'fsa_date', 'development_date'].includes(fieldName)) {
                      getLeadData();
                  }
                  
                   if (fieldName == 'fsa_date' || fieldName == 'contract_date' || fieldName == 'construction_start_date' || fieldName == 'completion_date' || fieldName == 'warranty_date' || fieldName == 'new_status') {
                        getLeadData();
                   }

                   setIsModalOpen(false);
                   setSavedFields((prevSavedFields) => ({ ...prevSavedFields, [fieldName]: true }));
                   setTimeout(() => {
                        setSavedFields((prevSavedFields) => ({ ...prevSavedFields, [fieldName]: false }));
                   }, 3000);
             }
        })
        .catch((error) => { console.error("Error:", error); })
        .finally(() => { setIsSubmitting(false); });
    };


    const notesUpdate = (fieldName, value,) => {


        if (debounceTimeout) {
            clearTimeout(debounceTimeout);
        }
        const newTimeout = setTimeout(() => {
            if (isFormSubmit == false) {
                return;
            }


            var _body = {
                notes: value,

                id: editingNoteId
            }
            const token = localStorage.getItem('authToken');

            // Create headers with token if it exists
            const headers = {
                'Content-Type': 'application/json',
                'Authorization': token ? `Bearer ${token}` : ''
            };

            var url = Api.API_BASE_URL + 'crm/notes-update';
            fetch(url, {
                method: "POST",
                headers: headers,
                body: JSON.stringify(_body),
            })
                .then((response) => response.json())
                .then((Josn) => {
                    if (Josn.error !== '') {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: Josn.error });
                    } else {
                        setLeadsId(Josn.id);
                        if (fieldName === 'notes') {
                            const updatedNotes = notes.map((n) =>
                                n.id === editingNoteId ? { ...n, notes: value } : n
                            );

                            setNotes(updatedNotes);
                            toast.current.show({ severity: 'success', summary: 'Success', detail: Josn.result });
                            setEditingNoteId(null);
                            setIsSavingNotes(false);
                            formik.setFieldValue('notes', '');
                        }




                        setIsModalOpen(false);
                        setSavedFields((prevSavedFields) => ({ ...prevSavedFields, [fieldName]: true }));

                        setTimeout(() => {
                            setSavedFields((prevSavedFields) => ({ ...prevSavedFields, [fieldName]: false }));
                        }, 3000);
                    }
                })
                .catch((error) => {
                    console.error("Error:", error);
                })
                .finally(() => {
                    setIsSubmitting(false);
                });

        }, 1500);
        setDebounceTimeout(newTimeout);
    };


    const renderDropdown = (label, fieldName, options, optionLabel) => (
        <div className="col-12 pt-2" style={{ position: 'relative' }}>
            <label className='Leads-heading' style={{ fontSize: '14px' }}>{label}</label>
            {savedFields[fieldName] && (
                <span style={{ position: 'absolute', top: 2, zIndex: 10, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '20px', height: '20px', borderRadius: '50%', backgroundColor: '#22c55e', color: 'white' }}>
                    <i className="pi pi-check" style={{ fontSize: '11px' }} />
                </span>
            )}
            <Dropdown
                optionValue='id'
                id={fieldName}
                name={fieldName}
                // placeholder={`select ${label.toLowerCase()}`}
                placeholder={`select ${label.charAt(0).toUpperCase() + label.slice(1).toLowerCase()}`}
                options={options}
                optionLabel={optionLabel}
                value={formik.values[fieldName] == 'NOT PROCEEDING' ? 'NOT PROCEEDING TO FSA' : formik.values[fieldName] == 'NOT PROCEEDING FSA' ? 'NOT PROCEEDING TO CONTRACT' : formik.values[fieldName]}
                onChange={(e) => {
                    onInputChange(fieldName, e.value);
                    if (fieldName === 'fsa_stage') { setDateChangeOrNot(true); }
                }}
                className={classNames('p-2 rounded', { 'p-invalid': isFormFieldInvalid(fieldName) })} 
                style={{ width: '100%', fontWeight: '600', borderRadius: '8px' }}
            />
        </div>
    );

    const ProjectDropdownForManager = (label, fieldName) => (
        <div className="col-12 pt-2" style={{ position: 'relative' }}>
            <label className='Leads-heading' style={{ fontSize: '14px' }}>{label}</label>

            <Dropdown
                optionValue='user_id'
                id={fieldName}
                name={fieldName}
                // placeholder={`select ${label.toLowerCase()}`}
                placeholder={`Select ${label.charAt(0).toUpperCase() + label.slice(1).toLowerCase()}`}

                options={projectsManager}
                optionLabel={(e) => e.first_name + ' ' + e.last_name}
                value={formikProject.values[fieldName]}

                onChange={(e) => formikProject.setFieldValue(fieldName, e.target.value)}
                className={classNames('p-2 rounded', { 'p-invalid': isFormFieldInvalid(fieldName) })} 
                style={{ width: '100%', fontWeight: '600', borderRadius: '8px' }}
            />
        </div>
    );
    const ProjectDropdownForLeadAssignee = (label, fieldName) => {
        
        const handleOpenEmailDialog = () => {
             const selectedUserId = formik.values[fieldName];
             const initialRecipients = [];

             if (selectedUserId && selectedUserId !== '0' && selectedUserId !== 0) {
                 initialRecipients.push(selectedUserId);
             }

             setAssigneeEmailData({ 
                 subject: `Update on Lead: ${formik.values.first_name || ''} ${formik.values.last_name || ''}`, 
                 message: '', 
                 recipientIds: initialRecipients,
             });
             setIsAssigneeEmailOpen(true);
        };

        return (
        <div className="col-12 pt-2" style={{ position: 'relative' }}>
             <div className="flex justify-content-between align-items-center mb-1">
                <label className='Leads-heading' style={{ fontSize: '14px' }}>{label}</label>
                <div className="flex align-items-center gap-2">
                    <span className="text-gray-500 text-xs hidden md:inline">Click to email</span>
                    <Button 
                        icon="pi pi-envelope" 
                        className="p-button-rounded p-button-text p-button-sm" 
                        style={{ width: '1.5rem', height: '1.5rem', color: '#64748b' }}
                        onClick={handleOpenEmailDialog}
                        tooltip="Send Email to Assignee"
                        type="button"
                    />
                </div>
            </div>

            <Dropdown
                optionValue='user_id'
                id={fieldName}
                name={fieldName}
                // placeholder={`select ${label.toLowerCase()}`}
                placeholder={`Select ${label.charAt(0).toUpperCase() + label.slice(1).toLowerCase()}`}

                options={projectsManager}
                optionLabel={(e) => e.first_name + ' ' + e.last_name}
                value={formik.values[fieldName]}
                onChange={(e) => {
                    onInputChange(fieldName, e.value);

                }}
                // onChange={(e) => formikProject.setFieldValue(fieldName, e.target.value)}
                className={classNames('p-2 rounded', { 'p-invalid': isFormFieldInvalid(fieldName) })} 
                style={{ width: '100%', fontWeight: '600', borderRadius: '8px' }}
            />
        </div>
    )};


    const countryOptionTemplate = (option) => {

        const displayStatus = option.name;

        const color = getSeverity(displayStatus);
        return <Tag value={displayStatus} className='p-2' style={{ backgroundColor: color, color: '#FFFFFF' }} />;

    };
    const getSeverity = (status) => {

        switch (status) {



            case 'Opportunity':
                return '#FFC107'; //Green
            case 'Lead Closed':
                return '#003366';
            case 'Lead Lost':
                return '#A9A9A9';
            case 'Lead Hold':
                return '#FFA500';

            case 'Lead Turned Down':
                return '#4F4F4F';

            case 'FSA Development':
                return '#87CEEB';

            case 'FSA Construction':
                return '#228B22';
            case 'FSA Active':
                return '#228B22';

            case 'FSA Hold':
                return '#556B2F';

            case 'FSA Cancelled':
                return '#8B0000';

            case 'Contract Active':
                return '#2E8B57';

            case 'Contract Hold':
                return '#D4AF37';

            case 'Contract Cancelled':
                return '#DC143C';

            case 'Construction Start':
                return '#FFA500';

            case 'Construction Complete':
                return '#4682B4';

            case 'Warranty Complete':
                return '#708090';



            default:
                return '#00AC47';
        }
    };


    const selectedCountryTemplate = (option, props) => {
        if (option) {
            return (
                <div className="flex align-items-center">
                    <div>{option.name}</div>
                </div>
            );
        }

        return <span>{props.placeholder}</span>;
    };




    const renderDropdownDeclynedType = (label, fieldName, options, optionLabel) => (
        <div className="col-12 pt-2" style={{ position: 'relative' }}>
            <label className='Leads-heading' style={{ fontSize: '14px' }}>{label}</label>
            {savedFields[fieldName] && (
                <span style={{ position: 'absolute', top: 2, zIndex: 10, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '20px', height: '20px', borderRadius: '50%', backgroundColor: '#22c55e', color: 'white' }}>
                    <i className="pi pi-check" style={{ fontSize: '11px' }} />
                </span>
            )}
            <Dropdown
                optionValue='id'
                id={fieldName}
                name={fieldName}
                placeholder={`select ${label.toLowerCase()}`}
                options={options}
                optionLabel={optionLabel}
                itemTemplate={countryOptionTemplate}
                value={formik.values[fieldName]}
                onChange={(e) => {
                    onInputChange(fieldName, e.value);
                    if (fieldName === 'fsa_stage') { setDateChangeOrNot(true); }
                }}
                valueTemplate={selectedCountryTemplate}
                className={classNames('p-2 rounded', { 'p-invalid': isFormFieldInvalid(fieldName) })} 
                style={{ width: '100%', fontWeight: '600', borderRadius: '8px' }}
            />
        </div>
    );



    const countryOptionTemplate2 = (option) => {

        const displayStatus = option.name;

        const color = getSeverity2(displayStatus);
        return <Tag value={displayStatus} className='p-2' style={{ backgroundColor: color, color: '#FFFFFF' }} />;

    };

    const getSeverity2 = (status) => {
        switch (status) {
            case 'Renovation':
                return '#556B2F';

            case 'Custom Home':
                return '#008080';

            case 'Garden Suite':
                return '#008080';

            case 'House Lift':
                return '#556B2F';

            case 'Small Reno(Kitchen/Bath)':
                return '#556B2F';

            case 'Multi Family':
                return '#DC143C';

            case 'Development':
                return '#FFC107';

            case 'Commercial':
                return '#003366';

            case 'Interior Design Only':
                return '#FF7F50';

            case 'Tenant Improvements':
                return '#228B22';

            case 'ACTIVE':
                return 'success';

            case 'Active':
                return 'success';

            case 'TURNED DOWN':
                return 'secondary';

            case 'Turend Down':
                return 'secondary';

            case 'LOST':
                return 'danger';

            case 'Lost':
                return 'danger';

            case 'NOT PROCEEDING TO FSA':
                return 'warning';

            case 'Not Proceeding To Fsa':
                return 'warning';

            case 'NOT PROCEEDING TO CONTRACT':
                return 'primary';

            default:
                return 'success';

        }
    };

    const renderDropdownProjectType = (label, fieldName, options, optionLabel) => (
        <div className="col-12 pt-2" style={{ position: 'relative' }}>
            <label className='Leads-heading' style={{ fontSize: '14px' }}>{label}</label>
            {savedFields[fieldName] && (
                <span style={{ position: 'absolute', top: 2, zIndex: 10, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '20px', height: '20px', borderRadius: '50%', backgroundColor: '#22c55e', color: 'white' }}>
                    <i className="pi pi-check" style={{ fontSize: '11px' }} />
                </span>
            )}
            <Dropdown
                optionValue='id'
                id={fieldName}
                name={fieldName}
                placeholder={`select ${label.toLowerCase()}`}
                options={options}
                optionLabel={optionLabel}
                itemTemplate={countryOptionTemplate2}
                value={formik.values[fieldName]}
                onChange={(e) => {
                    onInputChange(fieldName, e.value);
                    if (fieldName === 'fsa_stage') { setDateChangeOrNot(true); }
                }}
                valueTemplate={selectedCountryTemplate}
                className={classNames('p-2 rounded', { 'p-invalid': isFormFieldInvalid(fieldName) })} 
                style={{ width: '100%', fontWeight: '600', borderRadius: '8px' }}
            />
        </div>
    );




    const renderInput = (label, fieldName, type = "text") => {
        // console.log('Value of', fieldName, ':', formik.values[fieldName]);
        const isEmailField = fieldName === 'email';

        return (
            <div className="col-12  pt-2" style={{ position: 'relative' }}>
                <div className="flex justify-content-between align-items-center mb-1">
                    <label className='Leads-heading' style={{ fontSize: '14px', }} >{label}</label>
                    {isEmailField && (
                        <Button
                            icon="pi pi-envelope"
                            className="p-button-rounded p-button-text p-button-sm"
                            style={{ width: '1.75rem', height: '1.75rem', color: '#64748b' }}
                            onClick={() => setIsClientEmailOpen(true)}
                            tooltip="Send Email to Client"
                            type="button"
                            disabled={!formik.values.email}
                        />
                    )}
                </div>
                {/* Conditionally render success message */}
                {savedFields[fieldName] && (
                    <span style={{ position: 'absolute', top: 2, zIndex: 10, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '20px', height: '20px', borderRadius: '50%', backgroundColor: '#22c55e', color: 'white' }}>
                        <i className="pi pi-check" style={{ fontSize: '11px' }} />
                    </span>
                )}
                <InputText
                    id={fieldName}
                    name={fieldName}
                    type={type}
                    autoComplete="off"
                    value={formik.values[fieldName]}
                    onChange={(e) => onInputChange(fieldName, e.target.value)}
                    className={classNames('p-2 ', { 'p-invalid': isFormFieldInvalid(fieldName) })} 
                    style={{ width: '100%', fontWeight: '600', }}
                />
            </div>
        )
    };

    const renderInputProject = (label, fieldName, type = "text") => (
        <div className="col-12  pt-2" style={{ position: 'relative' }}>
            <label className='Leads-heading' style={{ fontSize: '14px', }} >{label}</label>
            <InputText
                id={fieldName}
                name={fieldName}
                type={type}
                autoComplete="off"
                value={formikProject.values[fieldName]}
                onChange={(e) => formikProject.setFieldValue(fieldName, e.target.value)}
                className={classNames('p-2 ', { 'p-invalid': isFormFieldInvalid(fieldName) })} style={{ width: '100%', fontWeight: '600' }}
            />
        </div>
    );

    // 1. Add state for margin manual checkbox, synced with formikProject
    const isMarginManual = formikProject.values.is_margin_manual === 'Y';

    // Place this in the main body of EditLeads, not inside any function
    useEffect(() => {
        const contract = parseFloat(formikProject.values.contract_amount) || 0;
        let cost = parseFloat(formikProject.values.project_cost_fee) || 0;
        let margin = parseFloat(formikProject.values.project_cost_per) || 0;
    
        if (formikProject.values.is_margin_manual !== 'Y') {
            // Auto mode: calculate margin and markup from contract and cost
            let autoMargin = '';
            let autoMarkup = '';
            if (contract > 0) {
                autoMargin = (((contract - cost) / contract) * 100).toFixed(2);
                autoMarkup = (cost > 0 ? (((contract - cost) / cost) * 100).toFixed(2) : '');
            }
            if (formikProject.values.project_cost_per !== autoMargin) {
                formikProject.setFieldValue('project_cost_per', autoMargin);
            }
            if (formikProject.values.project_markup !== autoMarkup) {
                formikProject.setFieldValue('project_markup', autoMarkup);
            }
        } else {
            // Manual mode: user enters margin, calculate cost
            if (contract > 0 && margin !== '') {
                const manualCost = (contract - (contract * margin / 100)).toFixed(2);
                if (formikProject.values.project_cost_fee !== manualCost) {
                    formikProject.setFieldValue('project_cost_fee', manualCost);
                }

                let autoMarkup = (manualCost > 0 ? (((contract - manualCost) / manualCost) * 100).toFixed(2) : '');
                if (formikProject.values.project_markup !== autoMarkup) {
                    formikProject.setFieldValue('project_markup', autoMarkup);
                }                
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        formikProject.values.contract_amount,
        formikProject.values.project_cost_fee,
        formikProject.values.project_cost_per,
        formikProject.values.is_margin_manual
    ]);

    const renderInputProjectMargin = (label, fieldName, type = "text") => {
        const handleInputChange = (e) => {
            const value = e.target.value;
            formikProject.setFieldValue(fieldName, value);
        };

        const handleCheckboxChange = (e) => {
            const checked = e.checked;
            formikProject.setFieldValue('is_margin_manual', checked ? 'Y' : 'N');
            // If switching to auto, recalculate (optional, but not needed if useEffect is present)
        };

        const isMarginManual = formikProject.values.is_margin_manual === 'Y';

        return (
            <div className="col-12 pt-2" style={{ position: 'relative' }}>
                <label className='Leads-heading' style={{ fontSize: '14px', marginBottom: '4px', display: 'block' }}>{label}</label>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <Checkbox
                        inputId="marginManualCheckbox"
                        checked={isMarginManual}
                        onChange={handleCheckboxChange}
                        style={{ marginRight: '8px' }}
                    />
                    <InputText
                        id={fieldName}
                        name={fieldName}
                        type={type}
                        autoComplete="off"
                        value={formikProject.values[fieldName] || ''}
                        onChange={handleInputChange}
                        className={classNames('p-2 rounded', { 'p-invalid': isFormFieldInvalid(fieldName) })}
                        style={{ width: '100%', fontWeight: '600', borderRadius: '8px' }}
                        disabled={!isMarginManual}
                        placeholder={label}
                    />
                </div>
            </div>
        );
    };

    // // 2. Update renderInputProjectMargin to include the checkbox and control disabled state and value
    // const renderInputProjectMargin = (label, fieldName, type = "text") => {
    //     // Handler for manual input
    //     const handleInputChange = (e) => {
    //         const value = e.target.value;
    //         formikProject.setFieldValue(fieldName, value);
    //     };

    //     // Handler for checkbox
    //     const handleCheckboxChange = (e) => {
    //         const checked = e.checked;
    //         formikProject.setFieldValue('is_margin_manual', checked ? 'Y' : 'N');
    //         // If switching to auto, recalculate
    //         if (!checked) {
    //             const contract = parseFloat(formikProject.values.contract_amount) || 0;
    //             const cost = parseFloat(formikProject.values.project_cost_fee) || 0;
    //             let margin = '';
    //             if (contract > 0) {
    //                 margin = (((contract - cost) / contract) * 100).toFixed(2);
    //             }
    //             formikProject.setFieldValue(fieldName, margin);
    //         }
    //     };

    //     // Auto-calculate margin if not manual
    //     useEffect(() => {
    //         if (!isMarginManual) {
    //             const contract = parseFloat(formikProject.values.contract_amount) || 0;
    //             const cost = parseFloat(formikProject.values.project_cost_fee) || 0;
    //             let margin = '';
    //             if (contract > 0) {
    //                 margin = (((contract - cost) / contract) * 100).toFixed(2);
    //             }
    //             if (formikProject.values[fieldName] !== margin) {
    //                 formikProject.setFieldValue(fieldName, margin);
    //             }
    //         }
    //         // eslint-disable-next-line react-hooks/exhaustive-deps
    //     }, [formikProject.values.contract_amount, formikProject.values.project_cost_fee, isMarginManual]);

    //     return (
    //         <div className="col-12 pt-2" style={{ position: 'relative' }}>
    //             <label className='Leads-heading' style={{ fontSize: '14px', marginBottom: '4px', display: 'block' }}>{label}</label>
    //             <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
    //                 <Checkbox
    //                     inputId="marginManualCheckbox"
    //                     checked={isMarginManual}
    //                     onChange={handleCheckboxChange}
    //                     style={{ marginRight: '8px' }}
    //                 />
    //                 <InputText
    //                     id={fieldName}
    //                     name={fieldName}
    //                     type={type}
    //                     autoComplete="off"
    //                     value={formikProject.values[fieldName] || ''}
    //                     onChange={handleInputChange}
    //                     className={classNames('p-2 rounded', { 'p-invalid': isFormFieldInvalid(fieldName) })}
    //                     style={{ width: '100%', fontWeight: '600', borderRadius: '8px' }}
    //                     disabled={!isMarginManual}
    //                     placeholder={label}
    //                 />
    //             </div>
    //         </div>
    //     );
    // };


    // 2. Update renderInputProjectMargin to include the checkbox and control disabled state
    const renderInputProjectMarkup = (label, fieldName, type = "text") => {
        // Format value for display
        let displayValue = formikProject.values[fieldName];
        if (displayValue !== "" && displayValue !== undefined && !String(displayValue).includes("%")) {
            displayValue = `${displayValue}%`;
        }        
        
        // This is the handler for calculating and setting the result
        const handleInputChange = (e) => {
            // const value = e.target.value;
            // formikProject.setFieldValue(fieldName, value);

            let value = e.target.value.replace(/%/g, ""); // Remove any % sign
            // Optionally, allow only numbers and decimals
            value = value.replace(/[^0-9.]/g, "");
            formikProject.setFieldValue(fieldName, value);            

            // Check if it's a valid number and calculate 100 - value
            // if (!isNaN(value)) {
            //     const result = 100 - parseFloat(value);
            //     // Set the calculated result to a different field, e.g., `remaining_margin`
            //     formikProject.setFieldValue('project_markup', result);
            // }
        };

        return (
            <div className="col-12 pt-2" style={{ position: 'relative' }}>
                <label className='Leads-heading' style={{ fontSize: '14px', marginBottom: '4px', display: 'block' }}>{label}</label>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    {/* <Checkbox
                        inputId="marginManualCheckbox"
                        checked={isMarginManual}
                        onChange={e => setIsMarginManual(e.checked)}
                        style={{ marginRight: '8px' }}
                    /> */}
                    <InputText
                        id={fieldName}
                        name={fieldName}
                        type={type}
                        autoComplete="off"
                        value={formikProject.values[fieldName]}
                        // value={displayValue}
                        onChange={handleInputChange}
                        className={classNames('p-2 rounded', { 'p-invalid': isFormFieldInvalid(fieldName) })}
                        style={{ width: '100%', fontWeight: '600', borderRadius: '8px' }}
                        disabled= {true} //{!isMarginManual}
                        placeholder={label}
                    />
                </div>
            </div>
        );
    };

    const renderInputProject2 = (label, fieldName, type = "text", title = '') => (
        <div className="col-12  pt-2" style={{ position: 'relative' }}>
            <div>
                <label className='Leads-heading' style={{ fontSize: '14px', }} >{label}</label>
                <BsFillInfoCircleFill size={15} title={title} className='text-gray-500 hover:text-gray-900' />
            </div>
            <InputText
                id={fieldName}
                name={fieldName}
                type={type}
                autoComplete="off"
                value={formikProject.values[fieldName]}
                onChange={(e) => formikProject.setFieldValue(fieldName, e.target.value)}
                className={classNames('p-2 rounded', { 'p-invalid': isFormFieldInvalid(fieldName) })} 
                style={{ width: '100%', fontWeight: '600', borderRadius: '8px' }}
            />
        </div>
    );

    const



        renderInputDisable = (label, fieldName, type = "text") => (
            <div className="col-12  pt-2 px-0" style={{ position: 'relative' }}>
                <label className='Leads-heading' style={{ fontSize: '14px', }} >{label} </label>

                <InputText
                    id={fieldName}
                    name={fieldName}
                    disabled
                    type={type}
                    autoComplete="off"
                    value={formik.values[fieldName]}
                    className={classNames(' ', { 'p-invalid': isFormFieldInvalid(fieldName) })} style={{ width: '100%', fontWeight: '600' }}
                />
            </div>
        );

    const renderInputDisableLeads = (label, fieldName, type = "text") => (
        <div className="col-12  pt-2 px-0" style={{ position: 'relative' }}>
            <label className='Leads-heading' style={{ fontSize: '14px', }} >{label} </label>

            <InputText
                id={fieldName}
                name={fieldName}
                disabled
                type={type}
                autoComplete="off"
                // value={formik.values[fieldName] == 'builderForm' ? 'Builder' : formik.values[fieldName] == 'gravityForm' ? 'Gravity ' : 'Manual'}
                value={formik.values[fieldName] == 'builderForm' ? 'Builder' : formik.values[fieldName] == 'gravityForm' ? 'Gravity ' : formik.values[fieldName] == 'LeadForm' ? 'Manual ' : formik.values[fieldName]}
                className={classNames(' ', { 'p-invalid': isFormFieldInvalid(fieldName) })} style={{ width: '100%', fontWeight: '600' }}
            />
        </div>
    );

    const renderInputValue = (label, fieldName, title = "") => (
        <div className="col-12  pt-2" style={{ position: 'relative' }}>
            <div>
                <label className='Leads-heading' style={{ fontSize: '14px', }} >{label} </label>
                <BsFillInfoCircleFill size={15} title={title} className='text-gray-500 hover:text-gray-900' />
            </div>
            {savedFields[fieldName] && (
                <span style={{ position: 'absolute', top: 2, zIndex: 10, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '20px', height: '20px', borderRadius: '50%', backgroundColor: '#22c55e', color: 'white' }}>
                    <i className="pi pi-check" style={{ fontSize: '11px' }} />
                </span>
            )}
            <InputNumber
                inputId="currency-us"
                id={fieldName}
                name={fieldName}
                autoComplete="off"
                list="noSuggestions"
                value={formik.values[fieldName]}
                onChange={(e) => onInputChange(fieldName, e.value)}
                mode="currency"
                currency="USD"
                locale="en-US"
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        e.preventDefault();
                    }
                }}
                className={classNames({ 'p-invalid': isFormFieldInvalid(fieldName) })} style={{ width: '100%', fontWeight: '600' }}
            />
        </div>
    );

    const renderCheckBoxProject = (label, fieldName, title = "") => (
        <div className="col-12  pt-2" style={{ position: 'relative', height: '74px' }}>
            <div>
                <label className='Leads-heading' style={{ fontSize: '14px', }} >{label} </label>
                <BsFillInfoCircleFill size={15} title={title} className='text-gray-500 hover:text-gray-900' />
            </div>
            <Checkbox
                className="m-2"
                name="internal_job"
                style={{ width: '90%' }}
                value={formikProject.values[fieldName]}
                checked={formikProject.values[fieldName] == 'Y' ? true : false}
                onChange={(e) => {

                    formikProject.setFieldValue(fieldName, e.checked ? 'Y' : 'N');
                }}
            />

        </div>
    );

    const renderInputValueForProject = (label, fieldName, type = "text", title = "") => (
        <div className="col-12  pt-2" style={{ position: 'relative' }}>
            <div>
                <label className='Leads-heading' style={{ fontSize: '14px', }} >{label} </label>
                <BsFillInfoCircleFill size={15} title={title} className='text-gray-500 hover:text-gray-900' />
            </div>

            <InputNumber
                inputId="currency-us"
                id={fieldName}
                name={fieldName}
                autoComplete="off"
                list="noSuggestions"
                value={formikProject.values[fieldName]}
                onChange={(e) => formikProject.setFieldValue(fieldName, e.value)}
                mode="currency"
                currency="USD"
                locale="en-US"
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        e.preventDefault();
                    }
                }}
                className={classNames({ 'p-invalid': isFormFieldInvalid(fieldName) })} style={{ width: '100%', fontWeight: '600' }}
            />
        </div>
    );
    const renderInputValueForProjectN = (label, fieldName, type = "text", title = "") => (
        <div className="col-12  pt-2" style={{ position: 'relative' }}>
            <div>
                <label className='Leads-heading' style={{ fontSize: '14px', }} >{label} </label>
                {/* <BsFillInfoCircleFill size={15} title={title} className='text-gray-500 hover:text-gray-900' /> */}
            </div>

            <InputNumber
                inputId="currency-us"
                id={fieldName}
                name={fieldName}
                autoComplete="off"
                list="noSuggestions"
                value={formikProject.values[fieldName]}
                onChange={(e) => formikProject.setFieldValue(fieldName, e.value)}
                mode="currency"
                currency="USD"
                locale="en-US"
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        e.preventDefault();
                    }
                }}
                className={classNames({ 'p-invalid': isFormFieldInvalid(fieldName) })} style={{ width: '100%', fontWeight: '600' }}
            />
        </div>
    );
    const renderInputValueForProject2 = (label, fieldName, type = "text", title = "") => (
        <div className="col-12  pt-2" style={{ position: 'relative' }}>
            <div>
                <label className='Leads-heading' style={{ fontSize: '14px', }} >{label} </label>
                <BsFillInfoCircleFill size={15} title={title} className='text-gray-500 hover:text-gray-900' />
            </div>

            <InputNumber
                inputId="currency-us"
                id={fieldName}
                name={fieldName}
                autoComplete="off"
                list="noSuggestions"
                value={formikProject.values[fieldName]}
                onChange={(e) => formikProject.setFieldValue(fieldName, e.value)}
                mode="currency"
                currency="USD"
                locale="en-US"
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        e.preventDefault();
                    }
                }}
                className={classNames({ 'p-invalid': isFormFieldInvalid(fieldName) })} style={{ width: '100%', fontWeight: '600' }}
            />
        </div>
    );

    const renderDateInput = (label, fieldName, title = "") => (
        <div className="col-12 pt-2" style={{ position: 'relative' }}>
            <div>
                <label className='Leads-heading' style={{ fontSize: '14px' }}>{label}</label>
                <BsFillInfoCircleFill size={15} title={title} className='text-gray-500 hover:text-gray-900' />
            </div>
            {savedFields[fieldName] && (
                <span style={{ position: 'absolute', top: 2, zIndex: 10, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '20px', height: '20px', borderRadius: '50%', backgroundColor: '#22c55e', color: 'white' }}>
                    <i className="pi pi-check" style={{ fontSize: '11px' }} />
                </span>
            )}
            <InputText
                id={fieldName}
                name={fieldName}
                type='date'
                autoComplete="off"
                value={formik.values[fieldName]}
                onChange={(e) => {
                    onInputChange(fieldName, e.target.value);
                    if (fieldName === 'fsa_date') { setDateChangeOrNot(true); }
                }}
                className={classNames('p-2 rounded', { 'p-invalid': isFormFieldInvalid(fieldName) })} 
                style={{ width: '100%', fontWeight: '600', borderRadius: '8px' }}
            />
        </div>
    );

    const renderFsaDateInput = (label, fieldName, title = "") => (
        <div className="col-12 pt-2" style={{ position: 'relative' }}>
            <div>
                <label className='Leads-heading' style={{ fontSize: '14px' }}>{label}</label>
                <BsFillInfoCircleFill size={15} title={title} className='text-gray-500 hover:text-gray-900 ml-2' />
            </div>
            {savedFields[fieldName] && (
                <span style={{ position: 'absolute', top: 2, zIndex: 10, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '20px', height: '20px', borderRadius: '50%', backgroundColor: '#22c55e', color: 'white' }}>
                    <i className="pi pi-check" style={{ fontSize: '11px' }} />
                </span>
            )}
            <InputText
                id={fieldName}
                name={fieldName}
                type='date'
                autoComplete="off"
                value={formik.values[fieldName]}
                onChange={(e) => {
                    const newValue = e.target.value;
                    formik.setFieldValue(fieldName, newValue);
                    if (newValue && !isProject) {
                        setShowFsaConfirmDialog(true);
                    } else {
                        saveFieldImmediate(fieldName, newValue);
                    }
                }}
                className={classNames('p-2 rounded', { 'p-invalid': isFormFieldInvalid(fieldName) })} 
                style={{ width: '100%', fontWeight: '600', borderRadius: '8px' }}
            />
        </div>
    );

    const fieldBackgroundColors = {
        "contract_date": "#96ceb4",
        "construction_start_date": "#ffe1ff",
        "completion_date": "#ffcfb3"
    };

    const renderDateInput2 = (label, fieldName, title = "") => (

        <div className="col-12 pt-2" style={{ position: 'relative' }}>
            <div>
                <label className='Leads-heading' style={{ fontSize: '14px' }}>{label}</label>
                <BsFillInfoCircleFill size={15} title={title} className='text-gray-500 hover:text-gray-900' />
            </div>
            {savedFields[fieldName] && (
                <span style={{ position: 'absolute', top: 2, zIndex: 10, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '20px', height: '20px', borderRadius: '50%', backgroundColor: '#22c55e', color: 'white' }}>
                    <i className="pi pi-check" style={{ fontSize: '11px' }} />
                </span>
            )}
            <InputText
                id={fieldName}
                name={fieldName}
                type='date'
                autoComplete="off"
                value={formik.values[fieldName]}
                onChange={(e) => {
                    onInputChange(fieldName, e.target.value);
                    if (fieldName === 'fsa_date') { setDateChangeOrNot(true); }
                }}
                readOnly

                className={classNames('p-2 rounded', { 'p-invalid': isFormFieldInvalid(fieldName) })} 
                style={{ width: '100%', fontWeight: '600', background: fieldBackgroundColors[fieldName], borderRadius: '8px' }}

            />
        </div>
    );

    // const renderDateInput2 = (label, fieldName, title = "") => (
    //     <div className="col-12 pt-2" style={{ position: 'relative' }}>
    //         <div>
    //             <label className='Leads-heading' style={{ fontSize: '14px' }}>{label}</label>
    //         </div>
    //         {savedFields[fieldName] && (
    //             <Message severity="success" text=" Saved"
    //                 style={{
    //                     position: 'absolute',
    //                     top: 0,
    //                     // right: 0,
    //                     zIndex: 1,
    //                 }}
    //             />
    //         )}
    //         <InputText
    //             id={fieldName}
    //             name={fieldName}
    //             type='date'
    //             autoComplete="off"
    //             value={formik.values[fieldName]}
    //             onChange={(e) => {
    //                 onInputChange(fieldName, e.target.value);
    //                 if (fieldName === 'fsa_date') { setDateChangeOrNot(true); }
    //             }}
    //             className={classNames('p-2', { 'p-invalid': isFormFieldInvalid(fieldName) })} style={{ width: '100%', fontWeight: '600' }}
    //         />
    //     </div>
    // );

    const renderHtmlEditor = (label, fieldName) => (
        <div className="col-12 pt-3" style={{ position: 'relative' }}>
            <label className='Leads-heading' style={{ fontSize: '14px' }}>{label}</label>
            {savedFields[fieldName] && (
                <span style={{ position: 'absolute', top: 2, zIndex: 10, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '20px', height: '20px', borderRadius: '50%', backgroundColor: '#22c55e', color: 'white' }}>
                    <i className="pi pi-check" style={{ fontSize: '11px' }} />
                </span>
            )}
            <ReactQuill
                id={fieldName}
                name={fieldName}
                value={formik.values[fieldName]}
                onChange={(value) => {
                    if (fieldName === 'notes') {
                        formik.setFieldValue('notes', value);
                    } else {
                        onInputChange(fieldName, value)
                    }
                }}
                style={{ minHeight: '7.5em' }}
                className="px-0"
            />
        </div>
    );

    const renderHtmlEditorNotes = (label, fieldName) => (
        <div className="pt-3" style={{ position: 'relative' }}>
            <label className='Leads-heading' style={{ fontSize: '14px' }}>{label}</label>
            <ReactQuill
                id={fieldName}
                name={fieldName}
                value={formik.values[fieldName]}
                onChange={(value) => {
                    if (fieldName === 'notes') {
                        formik.setFieldValue('notes', value);
                    } else {
                        onInputChange(fieldName, value);
                    }
                }}
                style={{ minHeight: '7.5em', borderRadius: '8px' }}
                className="px-0 rounded"
            />
        </div>
    );

    const footerContent = (
        <div className='m-2' >
            <Button label="Cancel" title='Cancel' severity="secondary" className='p-1 m-1' onClick={() => setShowErrorDialog(false)} />
        </div>
    );

    const footerContentConfirmation = (
        <div className='m-2 ' >
            <Button label="Cancel" title='Cancel' severity="secondary" className='p-1 m-1' onClick={() => setShowConfirmationDialog(false)} />
            <Button label="No" title='No' severity="danger" className='p-1 px-4 m-1 mx-2' onClick={() => {
                setShowConfirmationDialog(false);
                setShowConfirmationDialogIsCall(true);
                setErrorTitle('');
                formik.setFieldValue('projectCreated', 'project not create');
                formik.handleSubmit();
            }} />

            <Button label="Yes" title='Yes' onClick={() => {
                setShowConfirmationDialog(false);
                setShowConfirmationDialogIsCall(true);
                setErrorTitle('');
                formik.setFieldValue('projectCreated', 'project create');
                formik.handleSubmit();
            }} severity="success" autoFocus className='p-1 px-4 m-1 mx-2' />
        </div>
    );

    // const handleDeleteNote = (noteId) => {
    //     // console.log('noteId:', noteId);
    //     var _body = {
    //         userId: localStorage.getItem('user_id'),
    //         id: noteId,
    //     };
    //     const token = localStorage.getItem('authToken');

    //     // Create headers with token if it exists
    //     const headers = {
    //         'Content-Type': 'application/json',
    //         'Authorization': token ? `Bearer ${token}` : ''
    //     };
    //     var url = Api.API_BASE_URL + 'leads-tracker/leads-notes-deleted';

    //     fetch(url, {
    //         method: "POST",
    //         headers: headers,
    //         body: JSON.stringify(_body),
    //     })
    //         .then((response) => response.json())
    //         .then((data) => {
    //             if (data.error === '') {
    //                 toast.current.show({ severity: 'success', summary: 'Success', detail: 'Note deleted successfully' });
    //                 setNotes(notes.filter((note) => note.id !== noteId));
    //             } else {
    //                 toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to delete note' });
    //             }
    //         })
    //         .catch((error) => {
    //             console.error('Error deleting note:', error);
    //         });
    // };

    const handleDeleteNote = (noteId) => {
        setNoteToDelete(noteId);
        setIsDeleteConfirmationModalOpen(true);
    };

    const confirmDelete = () => {
        if (noteToDelete) {
            // Proceed with the deletion
            var _body = {
                userId: localStorage.getItem('user_id'),
                id: noteToDelete,
            };
            const token = localStorage.getItem('authToken');

            const headers = {
                'Content-Type': 'application/json',
                'Authorization': token ? `Bearer ${token}` : ''
            };
            var url = Api.API_BASE_URL + 'leads-tracker/leads-notes-deleted';

            fetch(url, {
                method: "POST",
                headers: headers,
                body: JSON.stringify(_body),
            })
                .then((response) => response.json())
                .then((data) => {
                    if (data.error === '') {
                        toast.current.show({ severity: 'success', summary: 'Success', detail: 'Note deleted successfully' });
                        setNotes(notes.filter((note) => note.id !== noteToDelete));
                    } else {
                        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Failed to delete note' });
                    }
                })
                .catch((error) => {
                    console.error('Error deleting note:', error);
                })
                .finally(() => {
                    setIsDeleteConfirmationModalOpen(false);
                    setNoteToDelete(null);
                });
        }
    };

    const closeModal = () => {
        setIsDeleteConfirmationModalOpen(false);
        setNoteToDelete(null);
    };

    // TODO---------------------------
    const textareaStyle = {
        width: '100%',
        height: "40px",
        boxSizing: 'border-box',
        outline: 'none',
        fontSize: '16px',
        color: '#495057',
        display: 'flex',
        alignItems: 'center',
        padding: '8px',
        border: '0.5px solid #ccc',
        minWidth: '350px'
    };
    // TODO---------------------------

    const handleSaveNote = () => {
        const noteContent = formik.values.notes ? formik.values.notes.trim() : '';
    
        if (!noteContent) {
            toast.current.show({ severity: 'warn', summary: 'Warning', detail: 'Note cannot be empty.' });
            return; // Exit the function if the note is empty
        }
    
        setIsSavingNotes(true);
        if (editingNoteId != null) {
            notesUpdate('notes', noteContent);
        } else {
            onInputChange('notes', noteContent);
        }
    };

    const addLeadDetailsToMessage = () => {
        let detailsHtml = `<br/><hr/><h3>Lead Details</h3><ul>`;
        
        // Basic Info
        detailsHtml += `<li><strong>Name:</strong> ${formik.values.first_name || ''} ${formik.values.last_name || ''}</li>`;
        detailsHtml += `<li><strong>Email:</strong> ${formik.values.email || ''}</li>`;
        detailsHtml += `<li><strong>Phone:</strong> ${formik.values.phone_number || ''}</li>`;
        const address = `${formik.values.street_number || ''} ${formik.values.street_name || ''} ${formik.values.city || ''}`;
        if (address.trim()) detailsHtml += `<li><strong>Address:</strong> ${address}</li>`;
        if (formik.values.contact_date) detailsHtml += `<li><strong>Contact Date:</strong> ${formik.values.contact_date}</li>`;
        if (formik.values.lead_source) detailsHtml += `<li><strong>Lead Source:</strong> ${formik.values.lead_source}</li>`;
        if (formik.values.site_visit_date) detailsHtml += `<li><strong>First Meeting Date:</strong> ${formik.values.site_visit_date}</li>`;
        
        // Project Info
        if (formik.values.project_type) detailsHtml += `<li><strong>Project Type:</strong> ${formik.values.project_type}</li>`;
        if (formik.values.new_status) detailsHtml += `<li><strong>Status:</strong> ${formik.values.new_status}</li>`;
        if (formik.values.project_value) detailsHtml += `<li><strong>Project Value:</strong> $${formik.values.project_value}</li>`;
        detailsHtml += `</ul>`;

        // Notes
        if (notes && notes.length > 0) {
            detailsHtml += `<h3>Notes</h3><ul>`;
            notes.forEach(note => {
                const noteAuthor = note.name || 'User';
                const noteDate = note.created_at ? moment(note.created_at).format('MMM D, YYYY') : '';
                detailsHtml += `<li><strong>${noteDate} (${noteAuthor}):</strong> ${note.notes || ''}</li>`;
            });
            detailsHtml += `</ul>`;
        }

        // Signature
        const currentUserName = localStorage.getItem('name');
        const currentUserEmail = localStorage.getItem('email');
        if (currentUserName) {
             detailsHtml += `<br/><br/>--<br/><strong>${currentUserName}</strong>`;
             if (currentUserEmail) {
                 detailsHtml += `<br/>📧 <a href="mailto:${currentUserEmail}">${currentUserEmail}</a>`;
             }
             detailsHtml += `<br/>🌐 <a href="https://builderplaybook.net" target="_blank">builderplaybook.net</a>`;
        }

        setAssigneeEmailData(prev => ({
            ...prev,
            message: prev.message + detailsHtml
        }));
    };

    const handleSendAssigneeEmail = () => {
        if (!assigneeEmailData.recipientIds || assigneeEmailData.recipientIds.length === 0) {
             toast.current.show({ severity: 'error', summary: 'Error', detail: 'Please select at least one recipient.', life: 3000 });
             return;
        }
        
        // Prepare the body for the API
        const _body = {
            user_id: localStorage.getItem('user_id'),
            recipient_ids: assigneeEmailData.recipientIds, 
            subject: assigneeEmailData.subject,
            message: assigneeEmailData.message,
            // Add other necessary fields if required by your backend
        };

        const token = localStorage.getItem('authToken');
        const headers = {
            'Authorization': token ? `Bearer ${token}` : '',
            "Content-Type": "application/json",
        };

        // NOTE: This endpoint needs to be verified or created on the backend. 
        // Using a generic path based on other endpoints.
        fetch(Api.API_BASE_URL + 'crm/send-email-assignee', {
            method: 'POST',
            headers: headers,
            body: JSON.stringify(_body),
        })
        .then(response => response.json())
        .then(data => {
            if (data.error && data.error !== '') {
                toast.current.show({ severity: 'error', summary: 'Error', detail: data.error, life: 3000 });
            } else {
                toast.current.show({ severity: 'success', summary: 'Success', detail: 'Email sent successfully!', life: 3000 });
                setIsAssigneeEmailOpen(false);
            }
        })
        .catch((error) => {
             console.error('Error sending email:', error);
             // Verify if endpoint exists, otherwise just show success for UI demo if requested
             toast.current.show({ severity: 'info', summary: 'Info', detail: 'Email request sent (backend verification needed)', life: 3000 });
             setIsAssigneeEmailOpen(false);
        });
    };

    const assigneeEmailDialogFooter = (
        <div className="flex justify-content-end gap-2 pt-3 pb-4 pr-4">
            <Button label="Cancel" icon="pi pi-times" onClick={() => setIsAssigneeEmailOpen(false)} className="p-button-text p-button-secondary" />
            <Button label="Send Email" icon="pi pi-send" onClick={handleSendAssigneeEmail} className="customSave-button" />
        </div>
    );

    return (
        <div className="dashboard-container">
            <Toast ref={toast} />

            <Dialog 
                header={
                    <div className="flex align-items-center gap-2">
                        <div className="surface-100 border-circle p-2 flex align-items-center justify-content-center" style={{ width: '40px', height: '40px' }}>
                            <i className="pi pi-send text-blue-600 text-xl"></i>
                        </div>
                        <span className="text-xl font-bold text-900">Send Email</span>
                    </div>
                }
                visible={isAssigneeEmailOpen} 
                style={{ width: '600px', maxWidth: '90vw' }} 
                breakpoints={{ '960px': '75vw', '641px': '100vw' }}
                modal 
                className="p-fluid"
                onHide={() => setIsAssigneeEmailOpen(false)}
                footer={assigneeEmailDialogFooter}
            >
                <div className="flex flex-column p-4">
                     <div className="surface-50 border-round p-3 mb-4 flex align-items-start">
                        <i className="pi pi-info-circle text-blue-500 mr-2 mt-1 text-lg"></i>
                        <span className="text-600 line-height-3 text-sm">
                            Clicking send will notify the selected users via their registered email address.
                        </span>
                    </div>

                    <div className="field mb-4">
                        <label htmlFor="assigneeRecipients" className="font-semibold text-900 mb-2 block text-sm">
                            Recipients
                        </label>
                        <MultiSelect 
                            id="assigneeRecipients" 
                            value={assigneeEmailData.recipientIds} 
                            options={projectsManager} 
                            onChange={(e) => setAssigneeEmailData({...assigneeEmailData, recipientIds: e.value})} 
                            optionLabel={(e) => e.first_name + ' ' + e.last_name}
                            optionValue="user_id"
                            placeholder="Select Recipients" 
                            display="chip"
                            className="w-full"
                            style={{ height: '30px' }}
                        />
                    </div>

                    <div className="field mb-4">
                        <label htmlFor="assigneeSubject" className="font-semibold text-900 mb-2 block text-sm">
                            Subject
                        </label>
                        <InputText 
                            id="assigneeSubject" 
                            value={assigneeEmailData.subject} 
                            onChange={(e) => setAssigneeEmailData({...assigneeEmailData, subject: e.target.value})} 
                            className="w-full"
                            style={{ height: '30px' }}
                        />
                     </div>
                     <div className="field">
                        <div className="flex justify-content-between align-items-center">
                            <label htmlFor="assigneeMessage" className="font-semibold text-900 mb-2 block text-sm">
                                Message
                            </label>
                            <Button 
                                type="button" 
                                icon="pi pi-list" 
                                className="p-button-rounded p-button-text p-button-sm mb-2" 
                                style={{ width: '2.5rem', height: '2.5rem', color: '#64748b' }}
                                onClick={addLeadDetailsToMessage}
                                tooltip="Append all lead info and notes to message"
                            />
                        </div>
                        <ReactQuill 
                            id="assigneeMessage" 
                            theme="snow"
                            value={assigneeEmailData.message} 
                            onChange={(value) => setAssigneeEmailData({...assigneeEmailData, message: value})} 
                            style={{ height: '200px', marginBottom: '50px' }}
                        />
                     </div>
                </div>
            </Dialog>

            <Dialog header="Confirmation" headerClassName="centered-header" visible={showConfirmationDialog} style={{ width: '30vw' }} className="dashboard-dialog" dismissableMask={true} onHide={() => setShowConfirmationDialog(false)} footer={footerContentConfirmation}>
                {/* Dialog content */}
                <div className=" m-2 item-center justify-center">
                    <span style={{ marginBottom: '1rem' }}>It will create a project in production schedule and playbook. Do you want to continue ?</span>
                </div>
            </Dialog>

            <Dialog header="Confirmation" headerClassName="centered-header" visible={showFsaConfirmDialog} style={{ width: '30vw' }} className="dashboard-dialog" dismissableMask={true} onHide={() => setShowFsaConfirmDialog(false)} 
                footer={
                    <div>
                        <Button label="No" onClick={() => setShowFsaConfirmDialog(false)} className="p-button-text" />
                        <Button label="Yes" onClick={() => {
                            // Ensure development_date is consistent in DB before starting project (if present)
                            // if (formik.values.development_date) {
                            //     saveFieldImmediate("development_date", formik.values.development_date);
                            // }

                            setShowFsaConfirmDialog(false);
                            saveFieldImmediate("fsa_date", formik.values.fsa_date);
                            setDateChangeOrNot(true);
                        }} autoFocus />
                    </div>
                }
            >
                <div className="flex align-items-center justify-content-center">
                    <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                    <span><b>Are you sure you want to Start Project?</b></span>
                </div>
            </Dialog>

            <div className="dashboard-header">
                <div className="flex align-items-center gap-2">
                    <button type='button' onClick={() => navigate('/leads')} className='customSave-button flex align-items-center gap-2'>
                        <IoArrowBackSharp className='text-sm' />
                        <span>Back</span>
                    </button>
                    <h1 className="dashboard-title ml-3">{type === 'Add' ? 'Add Lead' : 'Edit Lead'}</h1>
                </div>
            </div>

            {/* // -----------dialog Box------- */}
            <div className='dashboard-card'>
                <form onSubmit={formik.handleSubmit}>
                  <div className="grid">
                    {/* //*---- Left Combined Container (Client + Schedule + Info) -------- */}
                    <div className="col-12 md:col-6">
                        <div className="grid">
                            {/* //*---- First Column (Client Details) -------- */}
                            <div className='col-12 md:col-6'>
                                <h4 className='section-header'>Client Details</h4>
                                {renderInput("First Name", "first_name")}
                                {renderInput("Last Name", "last_name")}
                                {renderInput("Email", "email", "text")}
                                {renderInput("Phone Number", "phone_number", "text")}
                                {renderInput("Street Number", "street_number")}
                                {renderInput("Street Name", "street_name")}
                                {renderInput("City", "city")}
                                {/* {renderInput("Postal Code", "postal_code")} */}
                                {renderDateInput("Contact Date*", "contact_date", "This is the date the client first contacted you.")}
                                {renderDropdown("Lead Source*", "lead_source", leadSourceList, "name")}

                                {formik.values.lead_source == "Referral" ? renderInput("Who Referred You", "who_referred_you") : null}


                                {ProjectDropdownForLeadAssignee("Lead Assignee", "assignee")}
                            </div>

                            {/* //*---- Second Column (Schedules) -------- */}
                            <div className='col-12 md:col-6'>
                                <h4 className='section-header'>Schedules</h4>
                                {renderDropdownProjectType("Project Type*", "project_type", projectTypeList, "name")}
                                {renderInputValue("Project Value", "project_value", "Estimated Project Value")}
                                {renderDropdownDeclynedType("Status", "new_status", statusList, "name")}
                        
                                {formik.values.new_status === 'FSA Cancelled' && renderDateInput("FSA Cancel Date", "fsa_cancelled_date")}
                                {formik.values.new_status === 'Contract Cancelled' && renderDateInput("Contract Cancelled", "contract_cancelled_date")}

                                {renderDateInput("First Meeting Date", "site_visit_date", "This is the date you had your first meeting with the client.")}
                                {renderDateInput("CE Sent out", "ce_sent_out", "This is the date you had your first meeting with the client.")}
                                {renderDateInput("FSA Signed Development Date", "development_date", "The Date the FSA Development Contract was signed.")}
                                {renderFsaDateInput("FSA Signed Construction Date", "fsa_date", "This is the date the client signed the FSA")}

                                {renderDateInput2("Contract Date", "contract_date", "The date the Construction Contract was signed. This date pulls from the Pre Construction playbook.")}

                                {renderDateInput2("Construction Start Date", "construction_start_date", "This date is pulled from the Pre Construction Playbook initially and later updated from the Construction playbook once construction starts.")}

                                {renderDateInput2("Construction Completion Date", "completion_date", "This date is pulled from the Pre Construction Playbook initially and later updated from the Construction playbook once construction starts.")}
                            </div>
                            
                            {/* //*---- Client Information + Description side by side -------- */}
                            <div className='col-12 md:col-6'>
                                <div className="pt-2" style={{ position: 'relative' }}>
                                    <label className='Leads-heading' style={{ fontSize: '14px' }}>Client Information</label>
                                    <InputTextarea
                                        id="cilentInformation"
                                        name="cilentInformation"
                                        readOnly
                                        autoComplete="off"
                                        rows={5}
                                        value={formik.values.cilentInformation}
                                        onChange={(e) => onInputChange("cilentInformation", e.target.value)}
                                        className={classNames('p-2 w-full', { 'p-invalid': isFormFieldInvalid("cilentInformation") })}
                                        style={{ width: '100%', fontWeight: '600', borderRadius: '8px' }}
                                    />
                                </div>
                            </div>
                            <div className='col-12 md:col-6'>
                                <div className="pt-2" style={{ position: 'relative' }}>
                                    <label className='Leads-heading' style={{ fontSize: '14px' }}>Description</label>
                                    {savedFields['project_desc'] && (
                                        <span style={{ position: 'absolute', top: 2, zIndex: 10, display: 'inline-flex', alignItems: 'center', justifyContent: 'center', width: '20px', height: '20px', borderRadius: '50%', backgroundColor: '#22c55e', color: 'white' }}>
                                            <i className="pi pi-check" style={{ fontSize: '11px' }} />
                                        </span>
                                    )}
                                    <InputTextarea
                                        id="project_desc"
                                        name="project_desc"
                                        autoComplete="off"
                                        rows={5}
                                        value={formik.values.project_desc}
                                        onChange={(e) => onInputChange("project_desc", e.target.value)}
                                        className={classNames('p-2 w-full', { 'p-invalid': isFormFieldInvalid("project_desc") })}
                                        style={{ width: '100%', borderRadius: '8px' }}
                                        placeholder="Add a description for this lead..."
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-12 md:col-6'>
                      <div style={{ minHeight: '100%' }}>

                        {isProject == true ? <div className='mb-5'>
                            <h4 className='section-header'>Project Details</h4>
                            <div className='grid'>
                                <div className='col-12 md:col-6'>
                                    {renderCheckBoxProject("Internal Job", "internal_job", "Tick this box for all internal projects.")}                                    
                                    {renderInputValueForProjectN("Contract Amount", "contract_amount",)}
                                    {renderInputProjectMargin("Margin % ", "project_cost_per", 'number')}
                                    {renderInputValueForProject("Actuals To Date", "actual_to_date", 'number', "This is the total paid to date for the project.")}
                                                                        
                                    {renderInputProject2("Hours Per Day", "hoursPerDay", 'number', "This is the estimated Project Manager hours per day required to manage the project.")}                                    
                                    
                                    {renderInputValueForProject2("Fixed Price", "fixed_price", 'number', "The Total profit amount expected at the end of the project.")}
                                </div>
                                <div className='col-12 md:col-6'>
                                    <div style={{ height: '72px' }}></div> {/* Empty space for alignment */}
                                    {renderInputValueForProjectN("Projected Cost - Fees", "project_cost_fee",)}
                                    {renderInputProjectMarkup("Markup % ", "project_markup", 'number')}
                                    {renderInputValueForProject("Actuals - Fees", "actual_fees", 'number', "This is the total contract amount minus the total fees paid")}                                    
                                                                        
                                    {renderInputValueForProject("Original Expected GP", "orig_expected_gp", 'number', "This is the original GP expected at the start of the project.")}
                                    {renderInputProject2("Fixed Months", "fixed_month", 'number', "The number of months after the completion date that the project profit is expected to be received.")}
                                </div>
                            </div>

                            <div className='grid' style={{ }}>
                                <div className='col-12 md:col-6'>
                                    {ProjectDropdownForManager("Development Manager", "development_manager")}
                                    {ProjectDropdownForManager("Project Manager", "pM")}
                                    {ProjectDropdownForManager("Job Autospy", "pM")}
                                    {ProjectDropdownForManager("Superintendent ", "sp_manager")}

                                </div>
                                <div className='col-12 md:col-6'>
                                    {ProjectDropdownForManager("Pre con Manager", "pre_con_manager")}
                                    {ProjectDropdownForManager("Interior Design", "interior_design")}
                                    {ProjectDropdownForManager("Warranty", "pM",)}

                                </div>
                            </div>
                            
                            <div className='mt-2' style={{ display: 'flex', justifyContent: 'end' }}>
                                <Button
                                    type="button"
                                    onClick={(e) => {
                                        setIsSavingProject(true);
                                        formikProject.handleSubmit();
                                    }}
                                    // onClick={formikProject.handleSubmit}
                                    title='Save the Date'
                                    style={{ cursor: 'pointer' }}
                                    disabled={isSubmitting || isSavingNotes}
                                    className="customSave-button mt-2"
                                >
                                    {isSavingProject ? (
                                        <div className='flex items-center gap-2 px-1 ' style={{ alignItems: 'center', }}>
                                            <Spinner size={16} color="#fff" />
                                            <span>Saving...</span>
                                        </div>
                                    ) : (
                                        <div className='flex items-center gap-2 px-1 ' style={{ alignItems: 'center', }}>
                                            <span>Save Project</span>
                                        </div>
                                    )}
                                </Button>
                            </div>
                        </div> : null}


                        <div className='mt-4'>
                            <h4 className='section-header'>Notes</h4>
                            <div className='grid'>
                                <div className='col-12'>
                                    {renderHtmlEditorNotes("Notes", "notes")}
                                </div>

                                <div className='mt-2' style={{ display: 'flex', justifyContent: 'end' }}>
                                    <Button
                                        type="button"
                                        // onClick={(e) => {
                                        //     setIsSavingNotes(true);
                                        //     if (editingNoteId != null) {
                                        //         notesUpdate('notes', formik.values.notes);

                                        //     } else {
                                        //         onInputChange('notes', formik.values.notes);
                                        //     }


                                        // }}
                                        onClick={handleSaveNote}
                                        title='Save the Date'
                                        style={{ cursor: 'pointer' }}
                                        disabled={isSubmitting || isSavingNotes}
                                        className="customSave-button mt-2"
                                    >
                                        {isSavingNotes ? (
                                            <div className='flex items-center gap-2 px-1 ' style={{ alignItems: 'center', }}>
                                                <Spinner size={16} color="#fff" />
                                                <span>Saving...</span>
                                            </div>
                                        ) : (
                                            <div className='flex items-center gap-2 px-1 ' style={{ alignItems: 'center', }}>
                                                <span>Save Note</span>
                                            </div>
                                        )}
                                    </Button>
                                </div>
                            </div>
                            
                            {/* Notes List Component or Loop goes here */}
                            <div className='mt-4' >
                                {getCombinedTimeline().map((item, index) => {
                                    if (item.type === 'email') {
                                        // Email item from email threads
                                        const email = item.data;
                                        return (
                                            <Card key={index} className="py-2 shadow-2xl mt-2 ml-2 leads-card timeline-card timeline-card-email">
                                                <div className='timeline-card-row'>
                                                    <div className='timeline-avatar timeline-avatar-email'>
                                                        <i className="pi pi-envelope"></i>
                                                    </div>

                                                    <div className='timeline-meta'>
                                                        <h5 className="timeline-title">
                                                            <span>{email.subject}</span>
                                                            {email.direction === 'incoming' ? (
                                                                <span className="timeline-badge timeline-badge-received">Received</span>
                                                            ) : (
                                                                <span className="timeline-badge timeline-badge-sent">Sent</span>
                                                            )}
                                                        </h5>
                                                        <p className="timeline-subtitle">
                                                            {email.direction === 'incoming' ? `From: ${email.from_email}` : `To: ${email.to_email}`}
                                                        </p>
                                                        <p className="timeline-date">{moment(item.date).format('MMMM DD, YYYY h:mm A')}</p>
                                                    </div>

                                                    <div className='timeline-message-content'>
                                                        <div dangerouslySetInnerHTML={{ __html: normalizeTimelineHtmlImages(email.message) }} />
                                                    </div>
                                                </div>
                                            </Card>
                                        );
                                    } else {
                                        // Note item (original notes display)
                                        const note = item.data;
                                        return (
                                            <Card key={index} className="py-2 shadow-2xl mt-2 ml-2 leads-card timeline-card timeline-card-note">
                                                <div className='timeline-card-row'>
                                                    {note.image ?
                                                        <img src={`${note.image}`} alt="Image" className="timeline-avatar" />
                                                        :
                                                        <img src="https://cdn-icons-png.flaticon.com/512/149/149071.png" alt="Image" className="timeline-avatar" />
                                                    }

                                                    <div className='timeline-meta'>
                                                        <h5 className="timeline-title">{note.name}</h5>
                                                        <p className="timeline-date">{moment(item.date).format('MMMM DD, YYYY h:mm A')}</p>
                                                    </div>

                                                    <div className='timeline-message-content'>
                                                        <div dangerouslySetInnerHTML={{ __html: normalizeTimelineHtmlImages(note.notes) }} />
                                                    </div>

                                                    <div className='timeline-actions'>
                                                        {note.type != 'email' ?

                                                            (
                                                                <>

                                                                    <IoMdCreate
                                                                        onClick={() => {
                                                                            setEditingNoteId(note.id);
                                                                            formik.setFieldValue('notes', note.notes);

                                                                        }}
                                                                        style={{
                                                                            fontSize: '20px',
                                                                            cursor: 'pointer',
                                                                            marginRight: '10px',
                                                                        }}
                                                                    />

                                                                    {/* <FaTrash onClick={() => handleDeleteNote(note.id)} style={{ color: 'darkred', marginRight: '10px', cursor: "pointer" }} /> */}


                                                                    <FaTrash onClick={() => handleDeleteNote(note.id)} style={{ color: 'darkred', marginRight: '10px', cursor: "pointer" }} />

                                                                </>
                                                            ) : null}
                                                    </div>
                                                </div>
                                            </Card>
                                        );
                                    }
                                })}
                            </div>
                        </div>

                      </div>
                    </div>
                  </div>
                </form>
            </div>

            {isDeleteConfirmationModalOpen && (
                <div className="modal">
                    <div className="small-modal-content">
                        <div className="modal-headerx">
                            <h5 className="modal-title">Delete Confirmation</h5>
                            <button className="modal-closex" onClick={closeModal}>
                                &times;
                            </button>
                        </div>
                        <div className="modal-bodyx">
                            <p>Are you sure you want to delete this note?</p>
                        </div>
                        <div className="modal-footer-cancelx">
                            <button className="cancel-buttonx" onClick={closeModal}>
                                Cancel
                            </button>
                            <button className="delete-buttonx" onClick={confirmDelete}>
                                Delete
                            </button>
                        </div>
                    </div>
                </div>
            )}

            <EmailDialog
                visible={isClientEmailOpen}
                onHide={() => setIsClientEmailOpen(false)}
                showName={formik.values.client || `${formik.values.first_name || ''} ${formik.values.last_name || ''}`.trim()}
                showEmail={formik.values.email}
                showId={editId}
                allSupervisors={projectsManager}
                toast={toast}
            />

        </div>
    );
};

export default EditLeads;

